<template lang='pug'>
  .container(id='app')
    Navbar
    router-view
</template>

<script>
import Navbar from './components/Navbar.vue';
import {mapActions} from 'vuex'

export default{
  async created(){
    const token = localStorage.getItem('token')
    if (token!=null && token!==''){
      const success = await this.login({username:token})
      if(success){
        this.navigate('/searchPaper')
      }
    }
  },
  components:{
    Navbar
  },
  methods:{
    ...mapActions('authentication', ['login'])
  }
}
</script>